var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPayment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.375 3.75H2.625C1.17759 3.75 0 4.92759 0 6.375V17.625C0 19.0724 1.17759 20.25 2.625 20.25H21.375C22.8224 20.25 24 19.0724 24 17.625V6.375C24 4.92759 22.8224 3.75 21.375 3.75ZM2.625 5.25H21.375C21.9953 5.25 22.5 5.7547 22.5 6.375V7.875H1.5V6.375C1.5 5.7547 2.0047 5.25 2.625 5.25ZM21.375 18.75H2.625C2.0047 18.75 1.5 18.2453 1.5 17.625V9.375H22.5V17.625C22.5 18.2453 21.9953 18.75 21.375 18.75Z",
    fill: "#496683"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 16.5H4.5C4.08581 16.5 3.75 16.1642 3.75 15.75V15C3.75 14.5858 4.08581 14.25 4.5 14.25H5.25C5.66419 14.25 6 14.5858 6 15V15.75C6 16.1642 5.66419 16.5 5.25 16.5Z",
    fill: "#496683"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/Payment.88b293496bfb835d421065a28bd9c61c.svg";
export { ForwardRef as ReactComponent };